import React from "react";
import LoadSpinner from "../../common/spinner/loadSpinner";
import Menucustom from "../../common/menu/menucustom";
import TicketsService from "./ticketsService";
import moment from "moment";
import { toast } from "react-toastify";
import "../../css/ticket/tickets.css";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { Modal, Button } from "react-bootstrap";
import { geDataFormat } from "../../common/utils"

  export default class Tickets extends React.Component{
    constructor(props){
      super(props);
      this.state = {
        loading: true,
        showTicketDetailModal: false,
        showAddTicketModal: false,
        showConfirmTicketModal: false,
        ticketDataTable: [],
        ticketTemporaryFile: {
          file: null,
          value: ""
        },
        newTicket: {
          oggetto: "",
          descrizione: "",
          categoria: ""
        },
        attachments: [],
        ticketHeaderTable: [
          {
            label: "Id ticket",
            field: "id",
            width: 100,
            attributes: {
              "aria-controls": "DataTable",
              "aria-label": "Name",
            },
          },
          {
            label: "Aperto da",
            field: "utente",
            width: 270,
          },
          {
            label: "Data apertura",
            field: "dataCreazione",
            width: 270,
          },
          {
            label: "Oggetto",
            field: "oggetto",
            width: 270,
          },
          {
            label: "Categoria",
            field: "categoria",
            width: 270,
          },
          {
            label: "Stato",
            field: "stato",
            width: 270,
          }
        ],
        categoriesList: [
          "Anomalia",
          "Nuova richiesta",
        ],
        statesList: [
          "Caricato",
          "Preso in carico",
          "Chiuso"
        ],
        selectedTicket: null,
        selectedTicketInfo: null,
        filter: {
          startDate: null,
          endDate: null,
          state: null
        }
      }
    }

    componentDidMount() {
      this.ticketsService = new TicketsService();
      let now = new Date();
      now.setHours(0);
      now.setMinutes(0);
      now.setSeconds(0);
      now.setMilliseconds(0);
      this.state.filter.startDate = moment(now).subtract(90, "d").format("YYYY-MM-DD");
      this.state.filter.endDate = moment(now).format("YYYY-MM-DD");
      this.state.filter.state = 0;
      this.getDataTable();
    }

    showErrorToast() {
      toast.error("Qualcosa e' andato storto, Riprova piu tardi")
    }

    getDataTable() {
      let endDate = moment(this.state.filter.endDate, "YYYY-MM-DD").toDate();
      endDate.setHours(23);
      endDate.setMinutes(59);
      endDate.setSeconds(59);
      this.ticketsService.getTicketList(
        this.state.filter.startDate != null && this.state.filter.startDate != undefined ? moment(this.state.filter.startDate, "YYYY-MM-DD").toDate().getTime() : null,
        this.state.filter.endDate != null && this.state.filter.endDate != undefined ? endDate.getTime() : null,
        this.state.statesList[this.state.filter.state],
        this.onSuccessLoadDataTableTicket.bind(this),
        () => {
          this.showErrorToast();
          this.setState({loading: false});
        }
      );
    }
    
    render(){
     let content = this.state.loading ? <LoadSpinner/>:
 
     <div id="wrapper">
        <Menucustom/>
        <div className="container-fluid">
          <br />
          <br />
          <div className="d-sm-flex align-items-center justify-content-between mb-6">
            <div className="row ticket-title-div ms-3 me-4">
              <h1 className="h1 mb-2 text-gray-800">
                Ticket aperti
              </h1>
              <button
                type="button"
                class="btn btn-warning"
                onClick={this.setShowAddTicketModal.bind(this)}
              >
                {" "}
                <i className="fas fa-plus fa-sm text-white"></i> &nbsp;Aggiungi ticket
              </button>
            </div>
          </div>
          <div className="col">
            {this.renderTableData()}
          </div>
        </div>
        {this.getModalTicketDetails()}
        {this.getModalAddTicket()}
        {this.getModalConfirmTicket()}
      </div>
     return ( 
         <div>{content}</div>
     );
    }
    
    onSuccessLoadDataTableTicket(resultBody) {
      let data = (resultBody != null && resultBody != undefined) ? resultBody.map((element) => {
        return {
          "id": element.id,
          "utente": element.utente,
          "dataCreazione": moment(element.dataCreazione).format("DD/MM/YYYY - HH:mm"),
          "categoria": element.categoria,
          "oggetto": element.oggetto,
          "descrizione": element.descrizione,
          "stato": element.stato
        }
      }) : [];
      this.setState((this.state.ticketDataTable = data));
      this.setState({loading: false});
    }

    dataObj() {
      for (const item of this.state.ticketDataTable) {
        item.clickEvent = () => this.changeSelectedTicketStatus(item);
      }
      var data = {
        columns: this.state.ticketHeaderTable,
        rows: this.state.ticketDataTable,
      };
      return data;
    }

    changeSelectedTicketStatus(element) {
      if(element != null) {
        this.ticketsService.getDetailTicket(element.id, this.setSelectedTicketInfo.bind(this), this.showErrorToast.bind(this));
        this.setShowTicketDetailModal(true, element);
      } else {
        this.setSelectedTicketInfo(null);
        this.setShowTicketDetailModal(false, null);
      }
    }

    setSelectedTicketInfo(ticket) {
      this.setState({selectedTicketInfo: ticket});
    }

    setShowTicketDetailModal(value, ticket) {
      this.setState({showTicketDetailModal: value});
      this.setState({selectedTicket: ticket});
    }

    setShowAddTicketModal(value) {
      this.setState({showAddTicketModal: value});
    }

    setShowConfirmTicketModal(value) {
      this.setState({showConfirmTicketModal: value});
    }

    renderTicketsStatuses() {
      if (this.state.selectedTicketInfo.stati && this.state.selectedTicketInfo.stati.length > 0) {
        return this.state.selectedTicketInfo.stati.map((stati, index) => {
          // console.log(stati);
          const { idStorico, operatore, stato, dataStato } =
            stati;
  
          return (
            <li className="w-auto py-3 text-center">
              {" "}
              <time datetime={this.dataStato}>
                {moment(dataStato).format("DD/MM/YYYY")} <br />
                {moment(dataStato).format("HH:mm")}
              </time>{" "}
              <span>
                <strong>{(operatore != null ? operatore.numMatricola + " - " : "") + stato}</strong>
              </span>
            </li>
          );
        });
      } else {
        return <tr> Dati sugli stati del ticket non disponibili.</tr>;
      }
    }

    onChangeStartDate(event) {
      this.state.filter.startDate = event.target.value;
      this.setState({ filter: this.state.filter });
    }
  
    onChangeEndDate(event) {
      this.state.filter.endDate = event.target.value;
      this.setState({ filter: this.state.filter });
    }

    stateSelectorHandler(event){
      this.state.filter.state = event.target.value;
      this.setState({ filter: this.state.filter })
    }

    checkDatiTicket() {
      if (
        (this.state.newTicket.categoria != null && this.state.newTicket.categoria != undefined && this.state.newTicket.categoria != "") &&
        this.state.newTicket.oggetto.length > 4 &&
        this.state.newTicket.descrizione.length > 4
      ) {
        return false
      } else {
        return true
      }
    }

    confirmTicket() {
      this.setShowAddTicketModal(false)
      this.setShowConfirmTicketModal(true)
    }

    cancelNewTicket() {
      if(this.state.showAddTicketModal) this.setShowAddTicketModal(false)
      if(this.state.showConfirmTicketModal) this.setShowConfirmTicketModal(false)
      this.resetNewTicketStatus()
    }

    resetNewTicketStatus() {
      this.setState({
        newTicket: {
          oggetto: "",
          descrizione: "",
          categoria: ""
        },
        attachments: [],
        ticketTemporaryFile: {
          file: null,
          value: ""
        }
      })
    }

    attachmentOnChanged = async (event) => {
      const file = event.target.files[0];
  
      if (file.size > 3145728) {
        this.setState({
          ticketTemporaryFile: "",
          fileSizeError: true,
        });
      } else {
        this.setState({
          ticketTemporaryFile: {
            value: event.target.value,
            file: file
          },
          fileSizeError: false
        });
      }
    }

    addAttachment() {
      let temporaryAttachments = this.state.attachments;
      let index = temporaryAttachments.length;
      temporaryAttachments[index] = this.state.ticketTemporaryFile.file;
      this.setState({
        ticketTemporaryFile: {
          file: null,
          value: ""
        },
        attachments: temporaryAttachments,
      });
      //console.log("Lenght: " + this.state.attachments.length);
    }

    removeAttachment(index) {
      let temporaryAttachments = this.state.attachments;
      temporaryAttachments.splice(index, 1);
      this.setState({
        attachments: temporaryAttachments,
      });
      //console.log("Lenght: " + this.state.attachments.length);
    }

    getModalAddTicket() {
      return <Modal size="lg" show={this.state.showAddTicketModal}>
        <Modal.Header>
          <Modal.Title>Nuovo ticket</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ maxHeight: "calc(100vh - 210px)", overflowY: "auto" }}
        >
          <fieldset className="border p-2 d-flex flex-column gap-2 m-2">
            <legend className="w-auto" style={{ color: "#4e73df" }}>
              Dettagli Ticket
            </legend>
            <div className="row">
              <div className="col-sm-4">Categoria *</div>
              <div className="col-sm-8">
                <select
                  onChange={this.categorySelectorHandler.bind(this)}
                  className="form-select"
                >
                  <option key="empty_category" value={""}>Seleziona una categoria</option>
                  {
                    this.state.categoriesList.map((number,index) => {
                      return <option key={"category_"+index} value={index}>{number}</option>
                    })
                  }
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4">Oggetto *</div>
              <div className="col-sm-8"><input className="form-control" maxLength={50} name="oggetto" onChange={(event)=>{this.newTicketInputHandler(event)}} type="text"/></div>
            </div>
            <div className="row">
              <div className="col-sm-4">Descrizione *</div>
              <div className="col-sm-8"><textarea className="form-control" maxLength={250} name="descrizione" onChange={(event)=>{this.newTicketInputHandler(event)}} type="text"/></div>
            </div>
          </fieldset>
          <fieldset className="border p-2 d-flex flex-column gap-2 m-2">
            <legend className="w-auto" style={{ color: "#4e73df" }}>
              Allegati
            </legend>
            <div className="ticket-new-attachment-div">
              <input
                className="form-control"
                type="file"
                accept=".png, .jpg, .jpeg, .pdf"
                disabled={this.state.attachments.length >= 3}
                value={this.state.ticketTemporaryFile.value}
                onChange={this.attachmentOnChanged.bind(this)}
                // disabled={this.state.disableInput}
              ></input>
              <Button
                disabled={this.state.ticketTemporaryFile.file == null || this.state.ticketTemporaryFile.file == undefined}
                onClick={()=>this.addAttachment()}
              >
                <i className="fas fa-plus" color="white" />
              </Button>
            </div>
            <small>
              Formati accettati: pdf, jpg, png. Massimo 3 file.
            </small>
            {this.state.errorDimensioneFile ? (
              <small className="text-danger">
                File superiore di 3 MB
              </small>
            ) : (
              ""
            )}
            {this.getAttachmentsTable(this.state.attachments, true)}
          </fieldset>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => this.cancelNewTicket()}
          >
            Chiudi
          </Button>
          <Button
            disabled={this.checkDatiTicket()}
            onClick={()=>this.confirmTicket()}
          >
            Conferma
          </Button>
        </Modal.Footer>
      </Modal>
    }

    showAttachment(attachment) {
      window.open(URL.createObjectURL(attachment), "_blank")
    }

    getAttachmentsTable(attachments, upload) {
      if(upload == null || upload == undefined) upload = false;
      return <table class="table table-bordered text-center">
        {" "}
        {attachments.map((dati, index) => {
          // console.log(dati.data);
          var giornoCorretto =
            new Date(dati.data).getDate() < 9
              ? "0" + new Date(dati.data).getDate()
              : new Date(dati.data).getDate();
          var meseCorretto =
            new Date(dati.data).getMonth() < 9
              ? "0" + (new Date(dati.data).getMonth() + 1)
              : new Date(dati.data).getMonth() + 1;
          var dataCoretta =
            giornoCorretto +
            "/" +
            meseCorretto +
            "/" +
            new Date(dati.data).getFullYear();
          return (
            <>
              {index === 0 ? (
                <thead>
                  <tr>
                    <th scope="col">Nome File</th>
                    <th scope="col">{upload ? "Visualizza" : "Scarica"}</th>
                    {upload &&<th scope="col">Rimuovi</th>}
                  </tr>
                </thead>
              ) : (
                ""
              )}
              <tbody>
                <tr className="">
                  <td>{dati.name}</td>
                  <td>
                    <button
                      className="btn btn-link"
                      onClick={() => {
                        if(upload) this.showAttachment(dati)
                        else this.ticketsService.getAttachment(
                          dati.id,
                          (attachment) => {
                            // Decodifica il file base64 in un array di byte
                            var binaryData = atob(attachment);

                            // Crea un array di byte dall'array di caratteri
                            var byteArray = new Uint8Array(binaryData.length);
                            for (var i = 0; i < binaryData.length; i++) {
                                byteArray[i] = binaryData.charCodeAt(i);
                            }
                            
                            let fileExtension = dati.name.split(".")[1]

                            // Crea un Blob contenente i dati decodificati
                            var blob = new Blob([byteArray],  { type: (fileExtension === "pdf" ? "application/" : "image/")+fileExtension });
                            
                            this.showAttachment(blob)
                          },
                          this.showErrorToast.bind(this)
                        )
                      }}
                    >
                      <i className="fas fa-download"></i>
                    </button>
                  </td>
                  {upload &&<td>
                    <button
                      className="btn btn-link"
                      style={{ color: "red" }}
                      onClick={() => this.removeAttachment(index)}
                    >
                      <i className="fas fa-trash" color="red"></i>
                    </button>
                  </td>}
                </tr>
              </tbody>
            </>
          );
        })}
      </table>
    }

    getModalTicketDetails() {
      return <Modal size="lg" show={this.state.showTicketDetailModal} dialogClassName='ticket-details-modal'>
        <Modal.Header>
          <Modal.Title>
            <span className="title">
              {"Ticket n° " + (this.state.selectedTicket ? this.state.selectedTicket.id : "")}
            </span>
            <span className="date">
              {"Aperto il " + (this.state.selectedTicket ? this.state.selectedTicket.dataCreazione : "")}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ maxHeight: "calc(100vh - 210px)", overflowY: "auto" }}
        >
          <div>
            {
              (this.state.selectedTicketInfo != null && this.state.selectedTicketInfo != undefined) ?
                <div className="column">
                  <div className="row">
                    <div className="ticket-details-text-column">
                      <div className="row">
                        <div className="col-sm-10">
                          <b>Aperto da:</b>{" "}
                          {this.state.selectedTicketInfo.utente}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-10">
                          <b>Oggetto:</b>{" "}
                          {this.state.selectedTicketInfo.oggetto}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-10">
                          <b>Descrizione:</b>{" "}
                          {this.state.selectedTicketInfo.descrizione}
                        </div>
                      </div>
                    </div>
                    <ul className="ticket-status w-auto">
                      {this.renderTicketsStatuses()}
                    </ul>
                  </div>
                  {this.getAttachmentsTable(this.state.selectedTicketInfo.allegati)}
                </div>
              : <LoadSpinner />
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => this.changeSelectedTicketStatus(null)}
          >
            Chiudi
          </Button>
        </Modal.Footer>
      </Modal>
    }

    getModalConfirmTicket(){
      return(
      <Modal size="sm" show={this.state.showConfirmTicketModal}>
        <Modal.Header>Conferma Ticket</Modal.Header>
        <Modal.Body>
          Confermi l'invio del ticket?
        </Modal.Body>
        <Modal.Footer>
          <Button
          onClick={()=>this.cancelNewTicket()}>
            Annulla
          </Button>
          <Button
          onClick={()=>this.sendTicket()}>
            {this.state.loadingButton ? <LoadSpinner/> : "Conferma"}
          </Button>
        </Modal.Footer>
  
      </Modal>
      )
    }

    sendTicket() {
      this.setState({loadingButton:true})
      this.ticketsService.saveTicket(this.state.newTicket,(idTicket)=>{
        toast.success("Ticket Inviato")
        this.sendAttachments(idTicket)
      },
      ()=>{
        this.setState({
          loadingButton:false,
        })
        this.setShowConfirmTicketModal(false)
        this.resetNewTicketStatus()
        toast.error("Qualcosa e' andato storto nell'invio del ticket, Riprova piu tardi")
      })
    }

    sendAttachments(idTicket, index) {
      if(index == null || index == undefined) index = 0;
      if(index < this.state.attachments.length) {
        let attachment = this.state.attachments[index];
        index = index+1;
        this.ticketsService.saveAttachment(idTicket, attachment, ()=>{
          toast.success("Allegato '"+ attachment.name +"' Inviato")
          this.sendAttachments(idTicket, index)
        },
        ()=>{
          toast.error("Qualcosa e' andato storto nell'invio dell'allegato '"+ attachment.name +"', Riprova piu tardi")
          this.sendAttachments(idTicket, index)
        })
      } else {
        setTimeout(()=>this.getDataTable(),3000);
        this.setState({
          loadingButton:false,
        })
        this.setShowConfirmTicketModal(false)
        this.resetNewTicketStatus()
      }
    }

    categorySelectorHandler(event){
      const {value} = event.target;
  
      if(value !== ""){
        this.setState({newTicket:{...this.state.newTicket, categoria:this.state.categoriesList[value]}})
      }else{
        this.setState({newTicket:{...this.state.newTicket, categoria:""}})
      }
    }

    newTicketInputHandler(event){
      const {name,value} = event.target;
      this.setState((prevState)=>({newTicket:{...prevState.newTicket, [name]:value}}))
    }

    renderTableData() {
      if(this.state.ticketDataTable &&
        this.state.ticketDataTable.length > 0) {
        return (
          <CDBContainer>
            <CDBCard border>
              <div className="container">
                <div className="row">
                  <div className="col">
                    <div className="col">Data Inizio: </div>
                    <div className="col">
                      <input
                        value={this.state.filter.startDate}
                        type="date"
                        className="form-control"
                        onChange={this.onChangeStartDate.bind(this)}
                      />
                    </div>
                  </div>
                  <div className="col">
                    <div className="col">Data Fine: </div>
                    <div className="col">
                      <input
                        value={this.state.filter.endDate}
                        type="date"
                        className="form-control"
                        onChange={this.onChangeEndDate.bind(this)}
                      />
                    </div>
                  </div>
                  <div className="col">
                    <div className="col">Stato: </div>
                    <div className="col">
                      <select
                        value={this.state.filter.state}
                        onChange={this.stateSelectorHandler.bind(this)}
                        className="form-select"
                      >
                        {
                          this.state.statesList.map((state,index) => {
                            return <option key={"state_"+index} value={index}>{state}</option>
                          })
                        }
                      </select>
                    </div>
                  </div>
                  <div className="col">
                    {/* <div className="col">Filtri: </div> */}
                    <br></br>
                    <div className="col">
                      <button
                        className="btn btn-warning ms-0 ms-lg-2"
                        style={{ width: "100%" }}
                        onClick={() => {
                          this.getDataTable();
                        }}
                      >
                        Applica Filtri
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <CDBCardBody>
                <CDBDataTable
                  sortable={false}
                  responsiveSm={true}
                  responsiveMd={true}
                  responsiveLg={true}
                  pagesAmount={3}
                  entriesLabel={""}
                  infoLabel={["Mostra da", "a", "di", "tickets totali"]}
                  paginationLabel={["<-", "->"]}
                  striped
                  bordered
                  hover
                  checkbox
                  data={this.dataObj()}
                  materialSearch
                />
              </CDBCardBody>
            </CDBCard>
          </CDBContainer>
        )
      } else {
        return (
          <>
            {" "}
            <div className="row form-group">
              <div className="col">
                <div className="col">Data Inizio: </div>
                <div className="col">
                  <input
                    value={this.state.filter.startDate}
                    type="date"
                    className="form-control"
                    onChange={this.onChangeStartDate.bind(this)}
                  />
                </div>
              </div>
              <div className="col">
                <div className="col">Data Fine: </div>
                <div className="col">
                  <input
                    value={this.state.filter.endDate}
                    type="date"
                    className="form-control"
                    onChange={this.onChangeEndDate.bind(this)}
                  />
                </div>
              </div>
              <div className="col">
                <div className="col">Stato: </div>
                <div className="col">
                  <select
                    value={this.state.filter.state}
                    onChange={this.stateSelectorHandler.bind(this)}
                    className="form-select"
                  >
                    {
                      this.state.statesList.map((state,index) => {
                        return <option key={"state_"+index} value={index}>{state}</option>
                      })
                    }
                  </select>
                </div>
              </div>
              <div className="col">
                {/* <div className="col d-none">Filtri</div> */}
                <br></br>
                <div className="col">
                  <button
                    className="btn btn-warning"
                    style={{ width: "100%" }}
                    onClick={() => {
                      this.getDataTable();
                    }}
                  >
                    Applica Filtri
                  </button>
                </div>
              </div>
            </div>
            <br></br>
            <h4>Nessun Ticket Trovato</h4>
          </>
        )
      }
    }
  
 }

 